import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { goRiceUrl } from '../constant/siteConstants';
import { logOut } from '../utils/logOut';

// Tokeni almak için bir yardımcı fonksiyon
const getToken = () => Cookies.get('token');
const getRefreshToken = () => localStorage.getItem('refreshToken') || '';

// Yeni bir Axios instance oluştur
const api = axios.create({
    baseURL: `${goRiceUrl}/api`,
    headers: {
        'Content-Type': 'application/json',
        'token': getToken()
    }
});

// Token'i isteğe ekleyen bir request interceptor
api.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['token'] = token;
        }
        return config;
    },
    error => Promise.reject(error) // İstek hatası varsa olduğu gibi döndür
);

// Token yenileme fonksiyonu (401 Unauthorized durumunda kullanılacak)
const refreshToken = async () => {
    try {
        const response = await axios.post(`${goRiceUrl}/api/refresh-token`, {
            token: getRefreshToken()
        });
        if (response.data?.token) {
            localStorage.setItem('token', response.data.token);
            return response.data.token;
        }
    } catch (error) {
        console.error("Token yenileme başarısız.");
        return null;
    }
};
let isHandling401Error = false;

const handleError = error => {
    if (!error.response) {
        console.error("Sunucuya bağlanılamıyor.");
    } else {
        const { status } = error.response;

        if (status === 401 && !isHandling401Error) {
            isHandling401Error = true;
            logOut(() => toast.error("Oturum süreniz dolmuş. Lütfen tekrar giriş yapın."), false);
            // window.location.href = '/login';
            return;
        } else if (status === 401) {
            // Sadece redirect yap, tekrar alert gösterme
            window.location.href = '/login';
            return;
        } else if (status === 403) {
            alert("Bu işlem için yetkiniz yok.");
        } else if (status === 404) {
            const apiUrl = error.config?.url || error.request?.responseURL || 'API';
            console.error(`İstek ucu "${apiUrl}" bulunamadı`);
        } else {
            console.error("Hata:", error.response.data.message);
        }
    }
    return Promise.reject(error);
};
// Response interceptor: Token yenileme işlemi ve diğer hata yönetimi
api.interceptors.response.use(
    response => response, // Başarılı yanıtları olduğu gibi döndür
    async error => {
        if (error.response?.status === 401) {
            // const newToken = await refreshToken();
            // if (newToken) {
            //     error.config.headers['Authorization'] = `Bearer ${newToken}`;
            //     return axios(error.config);
            // }
        }
        return handleError(error); // Diğer durumlar için hata yönetimi
    }
);

export default api;
